import React, { useState, useEffect } from "react";
import Card from "../../components/Card";
import Tabs from "../../components/Tabs";
import { useLocation } from "react-router-dom";
import InnerHeader from "../../components/InnerHeader";
import { useTitle } from "../../hooks/useTitle";
import Students from "./Students";
import StudentCourse from "./StudentCourse";
import SmallLoader from "../../components/SmallLoader.js";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import constant from "../../constant/constant.js";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { logout } from "../../store/authSlice.js";
import SingleDropdown from "../../components/SingleDropdown";
import SearchInput from "../../components/SearchInput";
import NoPermission from "../../components/NoPermission.js";

const MyStudent = () => {
  const { id } = useParams();
  const user = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [recordList, setRecordList] = useState([]);
  const [studentCourseInfo, setStudentCourseInfo] = useState([]);
  const [dataStatus, setDataStatus] = useState(false);
  const [filterApiStatus, setFilterApiStatus] = useState(false);
  const [filterStatus, setFilterStatus] = useState(0);
  const [allApiFilter, setAllApiFilter] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [studentInfoData, setStudentInfoData] = useState([]);
  const tabs = [
    { label: "Team", value: "teams" },
    { label: "Enrolled Students", value: "enroll" },
  ];
  const [selectedTab, setSelectedTab] = useState("teams");
  const [nextActiveTab, setNextActiveTab] = useState("1");
  const [studentCourseState, setStudentCourseState] = useState(null);
  useTitle("My Account - Access Your Account - Flapone Aviation");

  //Shreshth State Start Here
  const [autoLoader, setAutoLoader] = useState(false);
  const [displayMsg, setDisplayMsg] = useState("");
  const [students, setStudents] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [status, setStatus] = useState("");
  const [course, setCourse] = useState("");
  const [searchLabel, setSearchLabel] = useState("Search by");
  const [searchBy, setSearchBy] = useState("");
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [clearSignal, setClearSignal] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [userName, setUserName] = useState("");
  const location = useLocation();
  const pageRoleAccess = user.user_type; 

  const [listFilter, setListFilter] = useState(
    {
      "searchtext": "",
      "searchByOptions":"",
      "courseStatus":"",
      "courseId": "",
    }
  );
  
  //Shreshth State End Here

  const handleTabChange = (value) => {
    setSelectedTab(value);
  };

  useEffect(() => {
    const fetchEnrollments = async () => {
      const response = await axios({
        method: "post",
        url: `${constant.base_url}/student/my_student.php?fun=getEnrolledStudentList`,
        headers: { "Auth-Id": user.auth_id },
        data: { filter: listFilter },
      });
  
      if (response.data.data.status === "1" && response.data.data.data.length > 0) {
        handleTabChange("enroll");
      } else {
        handleTabChange("teams");
      }
    };
  
    fetchEnrollments();
  }, []);

  return (
    <>
    {pageRoleAccess === "company" ? (
      <>
      <InnerHeader
        heading="My Team"
        txtSubHeading="View and manage the list of team members, who have access to training opportunities. You can update team details, assign courses, or add new members as required.`"
        showButton={false}
        iconText="Add New Lead"
      />
      <Card className="account-conatiner bg1 mt16 p20 pb48">
        <Tabs
          tabs={tabs}
          showCheckboxes={false}
          showFilter={false}
          onTabChange={handleTabChange}
          selectedTab={selectedTab}
          nextActiveTab={nextActiveTab}
        />
        {selectedTab === "teams" && (
          <Students
          />
        )}
        {selectedTab === "enroll" && (
          <StudentCourse

          />
        )}
      </Card>
      </>
    ) : (
      <NoPermission displayMsg={"No permission to access this page"} />
    )}
    </>
  );
};

export default MyStudent;
